import React, { useEffect, useState } from 'react';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import { useGlobalContext } from '../../../../Contexts/GlobalContext';
import axios from 'axios';
import {
  asString,
  checkNumber,
  defaultAllocation,
  getServerError,
  PERCENTAGE_MAX,
  positiveOrUndefined,
  redirectFields,
  withValueError,
} from '../allocationUtils.js';
import DeleteModal from '../../../../components/DeleteModal';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';
import AllocationsLoader from './AllocationsLoader';
import RedirectInfo from './RedirectInfo';
import { HiInformationCircle } from 'react-icons/hi';
import {
  Button,
  Chip,
  colors,
  Divider,
  Field,
  HelperText,
  Label,
  NumberInput,
  TextInput,
  Toggle,
} from '../../../../components/UiComponents/Ui';
import {
  RiAddLine,
  RiCheckboxMultipleBlankLine,
  RiCheckLine,
  RiCloseLine,
  RiEditLine,
  RiEyeLine,
} from 'react-icons/ri';
import { getError, handleChange } from '../../../helperFunctions';
import MultiSelectDropdown from '../../../../components/MultiSelectDropdown';
import { useQuery } from '@tanstack/react-query';
import {
  createSurveyAllocation,
  getAllSurveyAllocations,
  getSurveyAllocationSuppliers,
  submitToggleAllocationStatus,
  submitToggleMiratsAllocationStatus,
  submitToggleMiratsRewardsOnly,
} from '../../../../Actions/surveyAllocationActions';
import Spinner from '../../../../components/Spinner';
import ErrorEmptyStateView from '../../../../components/ErrorEmptyStateView';
import { MdKeyboardArrowDown } from 'react-icons/md';
import {
  validateAddAllocatioinFirstStepSchema,
  validateAddSurveAllocationSchema,
} from '../surveyDetailsValidators';
import PersonInfo from '../../../../components/PersonInfo';
import HeaderPagination from '../../../../components/UiComponents/HeaderPagination';
import Pagination from '../../../../components/UiComponents/Pagination';
import EditAllocation from './EditAllocation';
import { typeOptions } from '../allocationUtils';
import { BASE_URL, formateZodError } from '../../../../Utlils.js';
import ConfirmationModal from '../../../../components/UiComponents/ConfirmationModal.jsx';

const LinksModalstyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 800,
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: 2,
};

const STEPS = ['Allocation details', 'Redirects'];

const Allocations = ({ data, type, id, getSingleSurvey }) => {
  const { setSnackbar, user, handleCopy, organization } = useGlobalContext();
  const [showRewardsOnlyConfirmModal, setShowRewardsOnlyConfirmModal] =
    useState(false);
  const [deleteM, setDeleteM] = useState({ open: false });
  const [linksModal, setLinksModal] = useState(false);
  const [redirectInfoModal, setRedirectInfoModal] = useState(false);
  const [addAllocationModal, setAddAllocationModal] = useState(false);
  const [addAlloationModalTab, setAddAlloationModalTab] = useState(1);
  const [allocationData, setAllocationData] = useState(defaultAllocation);
  const [expendedRedirectInfo, setExpendedRedirectInfo] = useState(1);
  const [formErrors, setFormErrors] = useState({});
  const [reset, setReset] = useState(false);
  const [page, setPage] = useState(1);
  const [rows, setRows] = useState(14);
  const [supplierStats, setSupplierStats] = useState({
    loading: true,
    data: [],
    error: false,
  });
  const [linksData, setLinksData] = useState({
    liveLink: '',
    testLink: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [editAllocationModal, setEditAllocationModal] = useState(false);
  const [editingAllocation, setEditingAllocation] = useState(null);
  const [showToggleConfirmModal, setShowToggleConfirmModal] = useState(false);
  const [selectedAllocation, setSelectedAllocation] = useState(null);
  const {
    data: surveyAllocations,
    isLoading: surveyAllocationsLoading,
    error: surveyAllocationsError,
    refetch: surveyAllocationsMutate,
  } = useQuery({
    queryKey: ['survey-allocations', id, page, rows, reset],
    queryFn: () =>
      getAllSurveyAllocations({
        surveyId: id,
        orgId: user?.organization?._id,
        rows,
        page,
        reset,
      }),
  });

  const {
    data: surveyAllocationSuppliers,
    isLoading: surveyAllocationSuppliersLoading,
    error: surveyAllocationSuppliersError,
    refetch: surveyAllocationSuppliersMutate,
  } = useQuery({
    queryKey: ['survey-allocation-suppliers', id],
    queryFn: () =>
      getSurveyAllocationSuppliers({
        surveyId: id,
        orgId: user?.organization?._id,
      }),
    enabled: !!id && addAllocationModal,
  });

  const getSupplierStats = async () => {
    try {
      setSupplierStats((prev) => ({ ...prev, loading: true, data: [] }));
      data?.allocation?.forEach((d) => {
        axios
          .get(
            `${BASE_URL}/session/get-supplier-stats?supId=${d?.supplierAccount?._id}&sId=${id}`,
          )
          .then((response) =>
            setSupplierStats((prev) => ({
              data: [...prev?.data, response.data],
              loading: false,
              error: false,
            })),
          );
      });
    } catch (error) {
      setSupplierStats((prev) => ({ ...prev, loading: false, error: true }));
      console.log('error in getSupplierStats', error?.message);
    }
  };

  const handleCloseModal = (e) => setDeleteM((prev) => ({ open: false }));
  const deleteSupplier = async (e) => {
    e.preventDefault();
    axios
      .put(
        `${BASE_URL}/survey/delete-supplier?sid=${id}&aid=${deleteM?.data?._id}`,
      )
      .then((res) => {
        getSingleSurvey();
        setDeleteM({ open: false });
        setSnackbar({
          msg: 'Supplier Deleted Successfully !',
          open: true,
          severity: 'success',
        });
      })
      .catch((er) => {
        getSingleSurvey();
        setDeleteM({ open: false });
        setSnackbar({
          msg: 'Something went wrong !',
          open: false,
          severity: 'error',
        });
      });
  };
  const handleOpenLinkModal = (e, supplierId) => {
    e.stopPropagation();
    setLinksModal(true);
    setLinksData({
      liveLink: `${window.location.origin}/DIY/v2/${id}/${supplierId}/${user?.organizationId}/start?t=0&r=xxxxx`,
      testLink: `${window.location.origin}/DIY/v2/${id}/${supplierId}/${user?.organizationId}/start?t=1&r=xxxxx`,
    });
  };

  const expectedCompletes = Number(data?.expectedMatrix?.expectedCompletes);
  const surveyCpi = Number(data?.setup?.surveyCpi);

  const isRequiredSamplePercentage =
    allocationData?.requiredSample?.label === 'percentage';

  const isCPIPercentage = allocationData?.CPI?.label === 'percentage';

  const sampleRule = {
    min: isRequiredSamplePercentage ? 0 : 1,
    max: isRequiredSamplePercentage
      ? PERCENTAGE_MAX
      : positiveOrUndefined(expectedCompletes),
    integer: !isRequiredSamplePercentage,
  };
  const cpiRule = {
    min: 0,
    max: isCPIPercentage ? PERCENTAGE_MAX : positiveOrUndefined(surveyCpi),
    integer: false,
  };

  const noSampleAvailable =
    !isRequiredSamplePercentage && sampleRule.max === undefined;

  const requiredSampleError =
    asString(getError(['requiredSample', 'value'], formErrors)) ||
    asString(getError(['requiredSample', 'label'], formErrors));

  const CPIError =
    asString(getError(['CPI', 'value'], formErrors)) ||
    asString(getError(['CPI', 'label'], formErrors));

  const resetModalState = () => {
    setAddAlloationModalTab(1);
    setAllocationData(defaultAllocation);
    setFormErrors({});
    setExpendedRedirectInfo(0);
    setIsSubmitting(false);
  };

  const handleClose = () => setAddAllocationModal(false);

  const handleBack = () => {
    setFormErrors({});
    setAddAlloationModalTab(1);
  };

  const handleTypeChange = (field, nextType) => {
    if (!nextType) return;
    setAllocationData((prev) => ({
      ...prev,
      [field]: { ...prev?.[field], label: nextType, value: '' },
    }));
    setFormErrors((prev) => ({ ...prev, [field]: undefined }));
  };

  const handleAddAllocation = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;

    try {
      if (addAlloationModalTab === 1) {
        const result =
          validateAddAllocatioinFirstStepSchema.safeParse(allocationData);
        let errors = result.success ? {} : formateZodError(result.error.errors);
        errors = withValueError(
          errors,
          'requiredSample',
          checkNumber(
            'Required number',
            allocationData?.requiredSample?.value,
            sampleRule,
            isRequiredSamplePercentage,
          ),
        );
        errors = withValueError(
          errors,
          'CPI',
          checkNumber(
            'CPI',
            allocationData?.CPI?.value,
            cpiRule,
            isCPIPercentage,
          ),
        );

        if (Object.keys(errors).length) {
          setFormErrors(errors);
          return;
        }
        setFormErrors({});
        setExpendedRedirectInfo(1);
        setAddAlloationModalTab(2);
        return;
      }

      const result = validateAddSurveAllocationSchema.safeParse(allocationData);
      if (!result.success) {
        setFormErrors(formateZodError(result.error.errors));
        const firstBad = result.error.errors.find(
          (er) => er.path[0] === 'suppliers' && typeof er.path[1] === 'number',
        )?.path[1];
        if (firstBad !== undefined) setExpendedRedirectInfo(firstBad + 1);
        return;
      }
      setFormErrors({});

      setIsSubmitting(true);
      const response = await createSurveyAllocation({
        ...result.data,
        surveyId: id,
      });
      // console.log('response=>', response);
      if (!response?.success) {
        throw new Error(response?.message || 'Something went wrong !');
      }
      await surveyAllocationSuppliersMutate();
      await surveyAllocationsMutate();
      setSnackbar({
        open: true,
        msg: 'Allocation added successfully !',
        severity: 'success',
      });
      handleClose();
    } catch (error) {
      console.log('error=>', error);
      setSnackbar({
        open: true,
        msg: error?.message || 'Something went wrong !',
        severity: 'error',
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSuppliersChange = (picked) => {
    const merged = picked.map(
      (opt) =>
        allocationData?.suppliers?.find((s) => s.value === opt.value) ?? opt,
    );
    handleChange(['suppliers'], merged, setAllocationData, setFormErrors);
  };

  const handleOpenEditAllocation = (allocation) => {
    setEditingAllocation(allocation);
    setEditAllocationModal(true);
  };

  const mutateAllocations = async (refreshSurvey = false) => {
    await Promise.all([
      surveyAllocationsMutate(),
      surveyAllocationSuppliersMutate(),
      refreshSurvey ? getSingleSurvey() : null,
    ]);
  };

  const handleToggleStatusClick = (allocation, isMiratsAllocation = false) => {
    if (!allocation) return;
    setSelectedAllocation({ ...allocation, isMiratsAllocation });
    setShowToggleConfirmModal(true);
  };
  const handleCloseStatusModal = () => {
    setSelectedAllocation({});
  };

  const handleConfirmStatusChange = async () => {
    if (!selectedAllocation) return;
    const allocation = selectedAllocation;

    const isMiratsAllocation = allocation?.isMiratsAllocation || false;
    const nextActive = !isMiratsAllocation
      ? !allocation?.isActive
      : !data?.miratsAllocation;
    try {
      const response = !isMiratsAllocation
        ? await submitToggleAllocationStatus({
            allocationId: allocation._id,
            surveyId: id,
          })
        : await submitToggleMiratsAllocationStatus({ surveyId: id });
      if (response?.error)
        throw new Error(getServerError(response, 'Unable to update status'));

      await mutateAllocations(isMiratsAllocation);

      setSnackbar({
        open: true,
        msg: `Allocation marked as ${nextActive ? 'active' : 'inactive'}`,
        severity: 'success',
      });
    } catch (error) {
      setSnackbar({
        open: true,
        msg: error?.message || 'Something went wrong !',
        severity: 'error',
      });
    }
  };
  const handleConfirmRewardsOnlyChange = async () => {
    try {
      const response = await submitToggleMiratsRewardsOnly({ surveyId: id });
      if (response?.error)
        throw new Error(
          getServerError(response, 'Unable to update Mirats Rewards only'),
        );

      await getSingleSurvey();

      setSnackbar({
        open: true,
        msg: response?.data?.miratsRewardsOnly
          ? 'Survey is now visible only to Mirats Rewards'
          : 'Survey is now visible to all publishers',
        severity: 'success',
      });
    } catch (error) {
      setSnackbar({
        open: true,
        msg: error?.message || 'Something went wrong !',
        severity: 'error',
      });
    }
  };
  const handleConfirmMiratsAllocationStausChange = async () => {};
  useEffect(() => {
    if (data?._id) {
      getSupplierStats();
    }
  }, [data?._id]);

  // console.log({
  //   surveyAllocations,
  //   surveyAllocationsLoading,
  //   surveyAllocationsError,
  // });
  // console.log('allocationData=>', allocationData);
  // console.log('formErrors=>', formErrors);

  // console.log(allSuppliers);
  // console.log(teamMembers);
  // console.log(inputData);
  // console.log(filter);
  // console.log(edit);
  // console.log('supplierStats=>', supplierStats);
  // console.log('data=>', data);
  return (
    <div className="w-full flex flex-col gap-6">
      {/* Header */}
      <div className="w-full py-4 px-6 bg-white border-b border-[#E0E0E0] flex items-center justify-between">
        <div>
          <h1 className="text-[#0226BE] text-[24px] font-[500] mb-1">
            Allocations
          </h1>
          <p className="text-[#666] text-[14px] font-[400]">
            Supplier allocation and performance metrics
          </p>
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={() => setRedirectInfoModal(true)}
            className="flex items-center gap-2 px-4 py-2 bg-blue-50 hover:bg-blue-100 text-[#0226BE] rounded-md transition-colors text-[14px] font-[500] border border-blue-200"
          >
            <HiInformationCircle size={18} />
            Redirect Info
          </button>
          <Button onClick={() => setAddAllocationModal(true)}>
            <RiAddLine size={18} />
            Add Allocation
          </Button>
        </div>
      </div>

      <div className="space-y-2">
        <HeaderPagination
          date={surveyAllocations?.lastFetched}
          loading={surveyAllocationsLoading || supplierStats?.loading}
          pagination={{
            ...surveyAllocations?.pagination,
            totalDocuments: surveyAllocations?.pagination?.totalDocuments + 1,
          }}
          showReset={true}
          setReset={setReset}
          setPage={setPage}
          page={page}
        />

        <div className="w-full bg-white border border-[#E0E0E0] rounded-md overflow-hidden">
          {supplierStats?.loading || surveyAllocationsLoading ? (
            <AllocationsLoader />
          ) : supplierStats?.error || surveyAllocationsError ? (
            <div className="h-[200px] flex items-center justify-center">
              <h1 className="text-[#666]">Something went wrong</h1>
            </div>
          ) : (
            <div className="w-full overflow-x-auto containerScroll">
              <table
                className="whitespace-nowrap text-left w-full"
                id="table-to-xls-DATA"
              >
                <thead className="h-[50px] bg-gray-50 border-b border-[#E0E0E0]">
                  <tr>
                    <th className="text-[#666] text-[13px] font-[500] px-4 text-start">
                      Supplier
                    </th>
                    <th className="text-[#666] text-[13px] font-[500] px-4 text-start">
                      Allocation
                    </th>
                    <th className="text-[#666] text-[13px] font-[500] px-4 text-start">
                      CPI
                    </th>
                    <th className="text-[#666] text-[13px] font-[500] px-4 text-start">
                      Hits
                    </th>
                    <th className="text-[#666] text-[13px] font-[500] px-4 text-start">
                      Prescreens
                    </th>
                    <th className="text-[#666] text-[13px] font-[500] px-4 text-start">
                      Completes
                    </th>
                    <th className="text-[#666] text-[13px] font-[500] px-4 text-start">
                      Avg. CPI
                    </th>
                    <th className="text-[#666] text-[13px] font-[500] px-4 text-start">
                      Terminate
                    </th>
                    <th className="text-[#666] text-[13px] font-[500] px-4 text-start">
                      Remaining
                    </th>
                    <th className="text-[#666] text-[13px] font-[500] px-4 text-start">
                      Conversion
                    </th>
                    <th className="text-[#666] text-[13px] font-[500] px-4 text-start">
                      Status
                    </th>
                    <th className="text-[#666] text-[13px] font-[500] px-4 text-start">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data?.allocation?.map((allocation, ind) => {
                    return supplierStats?.data?.map((sd, key) => {
                      if (sd?.supplier === allocation?.supplierAccount?._id) {
                        return (
                          <tr
                            key={key}
                            className="border-b border-[#E0E0E0] transition-colors  hover:bg-blue-50/30"
                          >
                            <td className="px-4 py-4 text-[#333] font-[400] text-[14px]">
                              {allocation?.supplierAccount?.supplierName || '-'}
                            </td>
                            <td className="px-4 py-4 text-[#333] font-[400] text-[14px]">
                              {allocation?.allocation?.number || 0}
                            </td>
                            <td className="px-4 py-4 text-[#333] font-[400] text-[14px]">
                              {allocation?.cpi || 0}
                            </td>
                            <td className="px-4 py-4 text-[#333] font-[400] text-[14px]">
                              {sd?.hits || 0}
                            </td>
                            <td className="px-4 py-4 text-[#333] font-[400] text-[14px]">
                              {sd?.prescreen || 0}
                            </td>
                            <td className="px-4 py-4 text-[#333] font-[400] text-[14px]">
                              {sd?.completed || 0}
                            </td>
                            <td className="px-4 py-4 text-[#333] font-[400] text-[14px]">
                              {Number(sd?.avgCPI || 0).toFixed(2)}
                            </td>
                            <td className="px-4 py-4 text-[#333] font-[400] text-[14px]">
                              {sd?.term || 0}
                            </td>
                            <td className="px-4 py-4 text-[#333] font-[400] text-[14px]">
                              {Number(
                                allocation?.allocation?.number - sd?.completed,
                              ) > 0
                                ? allocation?.allocation?.number - sd?.completed
                                : 0}
                            </td>
                            <td className="px-4 py-4 text-[#333] font-[400] text-[14px]">
                              {sd?.conversion?.toFixed(2) || 0}%
                            </td>
                            <td className="px-4 py-4 text-[#333] font-[400] text-[14px]">
                              <Toggle
                                checked={data?.miratsAllocation}
                                onChange={(e) => {
                                  handleToggleStatusClick(allocation, true);
                                }}
                              />
                              {organization?.rewardsOnlyEnabled ? (
                                <div
                                  className="flex items-center gap-1 mt-1"
                                  title={
                                    data?.miratsAllocation
                                      ? 'Show this survey only to Mirats Rewards'
                                      : 'Enable Mirats allocation to use this option'
                                  }
                                >
                                  <Toggle
                                    id="mirats-rewards-only-toggle"
                                    checked={data?.miratsRewardsOnly}
                                    disabled={!data?.miratsAllocation}
                                    onChange={() =>
                                      setShowRewardsOnlyConfirmModal(true)
                                    }
                                  />
                                  <span className="text-[12px] text-[#667085] whitespace-nowrap">
                                    Mirats Rewards only
                                  </span>
                                </div>
                              ) : (
                                <></>
                              )}
                            </td>
                            <td className="px-4 py-4 text-[#333] font-[400] text-[14px] ">
                              <div className="flex items-center justify-center">
                                <div className="flex items-center gap-2">
                                  <RiEyeLine
                                    size={18}
                                    className="cursor-pointer hover:text-blue-600"
                                    onClick={(e) => {
                                      handleOpenLinkModal(
                                        e,
                                        allocation?.supplierAccount?._id,
                                      );
                                    }}
                                  />
                                  {/* <RiEditLine
                                  size={18}
                                  className="cursor-pointer hover:text-blue-600"
                                /> */}
                                </div>
                              </div>
                            </td>
                          </tr>
                        );
                      }
                    });
                  })}
                  {surveyAllocations?.data?.map((item, key) => (
                    <tr
                      key={key}
                      className="border-b border-[#E0E0E0] transition-colors  hover:bg-blue-50/30"
                    >
                      <td className="px-4 py-4 text-[#333] font-[400] text-[14px]">
                        <PersonInfo
                          name={item?.supplierData?.supplierName || '-'}
                          email={`${item?.allocationID}`}
                          link={`/suppliers/${item?.supplier}/setup`}
                          allowCopy={false}
                          openLinkInNewTab={true}
                        />
                      </td>
                      <td className="px-4 py-4 text-[#333] font-[400] text-[14px]">
                        {item?.requiredSample || 0}
                      </td>
                      <td className="px-4 py-4 text-[#333] font-[400] text-[14px]">
                        {item?.CPI || 0}
                      </td>
                      <td className="px-4 py-4 text-[#333] font-[400] text-[14px]">
                        {item?.sessionDetails?.hits || 0}
                      </td>
                      <td className="px-4 py-4 text-[#333] font-[400] text-[14px]">
                        {item?.sessionDetails?.prescreen || 0}
                      </td>
                      <td className="px-4 py-4 text-[#333] font-[400] text-[14px]">
                        {item?.sessionDetails?.completed || 0}
                      </td>
                      <td className="px-4 py-4 text-[#333] font-[400] text-[14px]">
                        {Number(item?.sessionDetails?.avgCPI || 0).toFixed(2)}
                      </td>
                      <td className="px-4 py-4 text-[#333] font-[400] text-[14px]">
                        {(item?.sessionDetails?.terminate || 0) +
                          (item?.sessionDetails?.securityTerminate || 0)}
                      </td>
                      <td className="px-4 py-4 text-[#333] font-[400] text-[14px]">
                        {Number(
                          item?.requiredSample -
                            item?.sessionDetails?.completed,
                        ) > 0
                          ? item?.requiredSample -
                            item?.sessionDetails?.completed
                          : 0}
                      </td>
                      <td className="px-4 py-4 text-[#333] font-[400] text-[14px]">
                        {item?.sessionDetails?.conversion?.toFixed(2) || 0}%
                      </td>
                      <td className="px-4 py-4 text-[#333] font-[400] text-[14px]">
                        <Toggle
                          checked={item?.isActive}
                          onChange={(e) => {
                            handleToggleStatusClick(item);
                          }}
                        />
                      </td>
                      <td className="px-4 py-4 text-[#333] font-[400] text-[14px] ">
                        <div className="flex items-center justify-center">
                          <div className="flex items-center gap-2">
                            <RiEyeLine
                              size={18}
                              className="cursor-pointer hover:text-blue-600"
                              onClick={(e) => {
                                handleOpenLinkModal(e, item?.supplier);
                              }}
                            />
                            <RiEditLine
                              size={18}
                              className="cursor-pointer hover:text-blue-600"
                              onClick={(e) => {
                                handleOpenEditAllocation(item);
                              }}
                            />
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* Footer */}
              {surveyAllocations?.pagination?.totalPages > 1 && (
                <Pagination
                  page={page + 1}
                  setPage={setPage}
                  rows={rows}
                  setRows={setRows}
                  totalDocuments={
                    (surveyAllocations?.pagination?.totalDocuments || 0) + 1
                  }
                />
              )}
            </div>
          )}
        </div>
      </div>

      <DeleteModal
        open={deleteM?.open}
        handleClose={handleCloseModal}
        text={deleteM?.data?.supplierAccount?.supplierName}
        handleClick={deleteSupplier}
      />
      {/* LINKS MODAL */}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={linksModal}
        onClose={() => {
          setLinksModal(false);
          setLinksData({
            liveLink: '',
            testLink: '',
          });
        }}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={linksModal}>
          <Box sx={LinksModalstyle}>
            <div className="w-full py-6 px-6 flex flex-col">
              <div className="flex justify-between items-center mb-6 pb-4 border-b border-[#E0E0E0]">
                <h1 className="text-[#333] text-[20px] font-[500]">
                  View Links
                </h1>
                <div className="flex items-center gap-2">
                  <button
                    onClick={() => {
                      setLinksModal(false);
                      setRedirectInfoModal(true);
                    }}
                    className="flex items-center gap-2 px-4 py-2 bg-blue-50 hover:bg-blue-100 text-[#0226BE] rounded-md transition-colors text-[14px] font-[500] border border-blue-200"
                  >
                    <HiInformationCircle size={18} />
                    Redirect Info
                  </button>
                  <button
                    className="px-4 py-2 text-white rounded-md bg-[#0226BE] text-[14px] font-[500] hover:bg-[#021ea8] transition-colors"
                    onClick={(e) => {
                      navigator.clipboard.writeText(
                        `Live Link = ${linksData?.liveLink} \nTest Link = ${linksData?.testLink}`,
                      );
                      setSnackbar({
                        msg: 'Both Links Copied to Clipboard!',
                        open: true,
                        severity: 'success',
                      });
                    }}
                  >
                    Copy Both Links
                  </button>
                </div>
              </div>
              <div className="flex flex-col gap-4">
                <div className="flex w-full gap-3 items-end">
                  <TextField
                    id="outlined-required"
                    label="Live Link"
                    className="flex-1"
                    value={linksData?.liveLink}
                    disabled
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                          borderColor: '#E0E0E0',
                        },
                      },
                    }}
                  />
                  <button
                    className="px-4 py-2.5 text-white rounded-md bg-[#0226BE] text-[14px] font-[500] hover:bg-[#021ea8] transition-colors whitespace-nowrap"
                    onClick={() => {
                      navigator.clipboard.writeText(linksData?.liveLink);
                      setSnackbar({
                        msg: 'Live Link Copied to Clipboard!',
                        open: true,
                        severity: 'success',
                      });
                    }}
                  >
                    Copy Link
                  </button>
                </div>
                <div className="flex w-full gap-3 items-end">
                  <TextField
                    id="outlined-required"
                    label="Test Link"
                    className="flex-1"
                    value={linksData?.testLink}
                    disabled
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                          borderColor: '#E0E0E0',
                        },
                      },
                    }}
                  />
                  <button
                    className="px-4 py-2.5 text-white rounded-md bg-[#0226BE] text-[14px] font-[500] hover:bg-[#021ea8] transition-colors whitespace-nowrap"
                    onClick={() => {
                      navigator.clipboard.writeText(linksData?.testLink);
                      setSnackbar({
                        msg: 'Test Link Copied to Clipboard!',
                        open: true,
                        severity: 'success',
                      });
                    }}
                  >
                    Copy Link
                  </button>
                </div>
              </div>
            </div>
          </Box>
        </Fade>
      </Modal>

      {/* Add Allocation Modal */}
      <Dialog
        open={addAllocationModal}
        onClose={(_, reason) => {
          if (reason === 'backdropClick') return;
          handleClose();
        }}
        TransitionProps={{ onExited: resetModalState }}
        maxWidth="sm"
        fullWidth
        scroll="paper"
        aria-labelledby={`${id}-title`}
        PaperProps={{
          component: 'form',
          onSubmit: handleAddAllocation,
          noValidate: addAlloationModalTab === 2,
          sx: {
            borderRadius: '12px',
            width: '100%',
            minWidth: 600,
            boxSizing: 'border-box',
          },
        }}
      >
        <DialogTitle component="div" sx={{ pb: 1 }}>
          <div className="flex items-start justify-between">
            <h1 id={`${id}-title`} className="text-xl font-[600] text-gray-900">
              Add Allocation
            </h1>
            <button
              type="button"
              aria-label="Close"
              onClick={handleClose}
              className="rounded p-1 text-gray-500 hover:bg-gray-100"
            >
              <RiCloseLine size={20} />
            </button>
          </div>

          {/* step indicator */}
          <ol className="mt-3 flex items-center gap-3">
            {STEPS.map((label, i) => {
              const step = i + 1;
              const done = addAlloationModalTab > step;
              const active = addAlloationModalTab === step;
              return (
                <li key={label} className="flex items-center gap-2">
                  <span
                    className={`flex h-6 w-6 items-center justify-center rounded-full text-xs font-semibold ${
                      done || active
                        ? 'bg-blue-600 text-white'
                        : 'bg-gray-200 text-gray-600'
                    }`}
                  >
                    {done ? <RiCheckLine size={14} /> : step}
                  </span>
                  <span
                    className={`text-sm ${active ? 'font-semibold text-gray-900' : 'text-gray-500'}`}
                  >
                    {label}
                  </span>
                  {step < STEPS.length && (
                    <span className="mx-1 h-px w-10 bg-gray-300" />
                  )}
                </li>
              );
            })}
          </ol>
        </DialogTitle>

        <DialogContent dividers sx={{ minHeight: 180, maxHeight: 350 }}>
          {surveyAllocationSuppliersLoading ? (
            <div className="flex h-[260px] items-center justify-center">
              <Spinner />
            </div>
          ) : surveyAllocationSuppliersError ? (
            <ErrorEmptyStateView
              type="error"
              title="Something went wrong"
              description="We couldn't load the suppliers. Please try again."
            />
          ) : surveyAllocationSuppliers?.data?.length === 0 ? (
            <ErrorEmptyStateView
              type="empty"
              title="No Available Suppliers found"
              description="Please add a new supplier"
            />
          ) : addAlloationModalTab === 1 ? (
            /* -------------------- step 1 -------------------- */
            <div className="space-y-5">
              <Field
                label="Select Supplier"
                required
                error={asString(getError(['suppliers'], formErrors))}
              >
                <MultiSelectDropdown
                  search
                  multiple
                  options={surveyAllocationSuppliers?.data || []}
                  dropdownText="Select Supplier"
                  selected={allocationData?.suppliers?.map((s) => ({
                    ...s,
                    label: s?.label,
                    value: s?.value,
                  }))}
                  setSelected={handleSuppliersChange}
                />
              </Field>

              {noSampleAvailable && (
                <p className="rounded-lg border border-warning-200 bg-warning-50 px-3 py-2 text-sm text-warning-800">
                  This survey has no expected completes configured, so a fixed
                  sample can't be allocated. Use a percentage or update the
                  survey setup.
                </p>
              )}

              <div className="grid grid-cols-2 items-start gap-4">
                {/* required number */}
                <div className="space-y-1">
                  <Label required>Required Number</Label>
                  <div className="flex items-start gap-2">
                    <div className="w-full">
                      <NumberInput
                        required
                        placeholder={
                          isRequiredSamplePercentage
                            ? 'Sample %'
                            : 'Sample Number'
                        }
                        min={sampleRule.min}
                        max={sampleRule.max}
                        step={sampleRule.integer ? 1 : 'any'}
                        value={allocationData?.requiredSample?.value || ''}
                        error={requiredSampleError}
                        onChange={(e) =>
                          handleChange(
                            ['requiredSample', 'value'],
                            e.target.value,
                            setAllocationData,
                            setFormErrors,
                          )
                        }
                      />
                    </div>
                    <MultiSelectDropdown
                      width="120px"
                      options={typeOptions}
                      selected={typeOptions.filter(
                        (opt) =>
                          opt.value === allocationData?.requiredSample?.label,
                      )}
                      setSelected={(v) =>
                        handleTypeChange('requiredSample', v?.[0]?.value)
                      }
                    />
                  </div>
                  {!!requiredSampleError && (
                    <HelperText>{requiredSampleError}</HelperText>
                  )}
                  {!requiredSampleError && sampleRule.max !== undefined && (
                    <HelperText error={false}>
                      Between {sampleRule.min} and {sampleRule.max}
                      {isRequiredSamplePercentage ? '%' : ''}
                    </HelperText>
                  )}
                </div>

                {/* CPI */}
                <div className="space-y-1">
                  <Label required>CPI</Label>
                  <div className="flex items-start gap-2">
                    <div className="w-full">
                      <NumberInput
                        required
                        placeholder={isCPIPercentage ? 'CPI %' : 'Add CPI'}
                        min={cpiRule.min}
                        max={cpiRule.max}
                        step="any"
                        value={allocationData?.CPI?.value || ''}
                        error={CPIError}
                        onChange={(e) =>
                          handleChange(
                            ['CPI', 'value'],
                            e.target.value,
                            setAllocationData,
                            setFormErrors,
                          )
                        }
                      />
                    </div>
                    <MultiSelectDropdown
                      width="120px"
                      options={typeOptions}
                      selected={typeOptions.filter(
                        (opt) => opt.value === allocationData?.CPI?.label,
                      )}
                      setSelected={(v) =>
                        handleTypeChange('CPI', v?.[0]?.value)
                      }
                    />
                  </div>
                  {!!CPIError && <HelperText>{CPIError}</HelperText>}
                  {!CPIError && cpiRule.max !== undefined && (
                    <HelperText error={false}>
                      Up to {cpiRule.max}
                      {isCPIPercentage ? '%' : ''}
                    </HelperText>
                  )}
                </div>
              </div>
            </div>
          ) : (
            /* -------------------- step 2 -------------------- */
            <div className="space-y-3 w-full ">
              {allocationData?.suppliers?.map((item, index) => {
                const globalRedirects = item?.globalRedirects || false;
                const redirectErrors = getError(
                  ['suppliers', index, 'redirects'],
                  formErrors,
                );
                const errorCount =
                  typeof redirectErrors === 'string'
                    ? 1
                    : redirectErrors && typeof redirectErrors === 'object'
                      ? Object.keys(redirectErrors).length
                      : 0;

                return (
                  <Accordion
                    key={item?.value ?? index}
                    disableGutters
                    elevation={0}
                    expanded={expendedRedirectInfo === index + 1}
                    onChange={(_, isExpanded) =>
                      setExpendedRedirectInfo(isExpanded ? index + 1 : 0)
                    }
                    sx={{
                      border: `1px solid ${errorCount ? colors.error500 : colors.gray200}`,
                      borderRadius: '8px !important',
                      '&:before': { display: 'none' },
                      width: '100%',
                    }}
                  >
                    <AccordionSummary
                      expandIcon={<MdKeyboardArrowDown size={20} />}
                      aria-controls={`${id}-panel-${index}`}
                      id={`${id}-header-${index}`}
                      sx={{ bgcolor: colors.gray50, borderRadius: '8px' }}
                    >
                      <div className="flex w-full items-center justify-between gap-3 pr-2">
                        <h2 className="text-sm font-semibold text-gray-900">
                          {item?.label}
                        </h2>
                        <div className="flex items-center gap-2">
                          {errorCount > 0 && (
                            <Chip intent="error">
                              {errorCount}{' '}
                              {errorCount === 1 ? 'error' : 'errors'}
                            </Chip>
                          )}
                          <Chip intent={globalRedirects ? 'purple' : 'primary'}>
                            {globalRedirects
                              ? 'Global Redirects'
                              : 'Dynamic Redirects'}
                          </Chip>
                        </div>
                      </div>
                    </AccordionSummary>

                    <AccordionDetails sx={{ pt: 2 }}>
                      <div className="space-y-4">
                        {redirectFields?.map((rd) => {
                          const value =
                            item?.redirects?.[rd?.dbFieldName] || '';
                          const fieldError = asString(
                            getError(
                              [
                                'suppliers',
                                index,
                                'redirects',
                                rd?.dbFieldName,
                              ],
                              formErrors,
                            ),
                          );
                          return (
                            <div
                              className="flex items-start justify-between"
                              key={rd?.dbFieldName}
                            >
                              <div className="flex items-center gap-2">
                                <div
                                  className={`h-[40px] border-l-[1.5px] ${rd.color}`}
                                />
                                <h3 className="text-sm font-medium text-gray-800">
                                  {rd?.label}
                                </h3>
                              </div>
                              <div className="w-[60%] space-y-1">
                                <TextInput
                                  type="url"
                                  required
                                  disabled={globalRedirects}
                                  placeholder="https://www.example.com/[%rid%]"
                                  value={value}
                                  error={fieldError}
                                  onChange={(e) =>
                                    handleChange(
                                      [
                                        'suppliers',
                                        index,
                                        'redirects',
                                        rd?.dbFieldName,
                                      ],
                                      e.target.value,
                                      setAllocationData,
                                      setFormErrors,
                                    )
                                  }
                                  endIcon={
                                    <button
                                      type="button"
                                      aria-label={`Copy ${rd?.label} redirect`}
                                      disabled={!value}
                                      className="text-gray-500 hover:text-gray-700 disabled:opacity-40"
                                      onClick={() =>
                                        handleCopy(value, rd?.label)
                                      }
                                    >
                                      <RiCheckboxMultipleBlankLine size={18} />
                                    </button>
                                  }
                                />
                                {globalRedirects && !value && (
                                  <HelperText>
                                    No global redirect is configured for this
                                    supplier. Set it in the supplier's Redirects
                                    tab.
                                  </HelperText>
                                )}
                                {!!fieldError && (
                                  <HelperText>{fieldError}</HelperText>
                                )}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </AccordionDetails>
                  </Accordion>
                );
              })}
            </div>
          )}
        </DialogContent>

        <DialogActions sx={{ px: 3, py: 2, gap: 1 }}>
          {addAlloationModalTab === 1 ? (
            <Button
              variant="outlined"
              intent="default"
              type="button"
              onClick={handleClose}
            >
              Close
            </Button>
          ) : (
            <Button
              variant="outlined"
              intent="default"
              type="button"
              onClick={handleBack}
            >
              Back
            </Button>
          )}
          <Button
            type="submit"
            disabled={
              isSubmitting ||
              surveyAllocationSuppliersLoading ||
              Boolean(surveyAllocationSuppliersError) ||
              !surveyAllocationSuppliers?.data?.length
            }
          >
            {addAlloationModalTab === 1
              ? 'Next'
              : isSubmitting
                ? 'Adding…'
                : 'Add Allocation'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Redirect Info Modal */}
      <RedirectInfo
        open={redirectInfoModal}
        onClose={() => setRedirectInfoModal(false)}
        surveyData={data}
        surveyId={id}
      />

      {/* toggle cofimartion modal */}
      <ConfirmationModal
        modalOpen={showToggleConfirmModal}
        setModalOpen={setShowToggleConfirmModal}
        title="Are You sure you want to toggle the allocation status?"
        description="This action will change the allocation status to the opposite of the current status."
        onSubmit={handleConfirmStatusChange}
        onClose={handleCloseStatusModal}
      />
      <ConfirmationModal
        modalOpen={showRewardsOnlyConfirmModal}
        setModalOpen={setShowRewardsOnlyConfirmModal}
        title={
          data?.miratsRewardsOnly
            ? 'Make this survey available to all publishers?'
            : 'Restrict this survey to Mirats Rewards only?'
        }
        description={
          data?.miratsRewardsOnly
            ? 'All publishers connected to the Mirats publisher network will be able to see and send respondents to this survey.'
            : 'Only Mirats Rewards will be able to see and send respondents to this survey. Other publishers will no longer see it.'
        }
        onSubmit={handleConfirmRewardsOnlyChange}
      />
      {/* Edit Allocation Modal */}
      <EditAllocation
        data={data}
        id={id}
        editAllocationModal={editAllocationModal}
        setEditAllocationModal={setEditAllocationModal}
        editingAllocation={editingAllocation}
        setEditingAllocation={setEditingAllocation}
        mutateAllocations={mutateAllocations}
      />
    </div>
  );
};

export default Allocations;
